export const CONDITIONS = {
  key: 'CONDITIONS',
  value: 0,
  group: 1,
  title: 'health-record.conditions.condition_title',
  menu_title: 'health-record.conditions.title',
  sub_title: 'health-record.conditions.condition-title-example',
  imageURL: require('@assets/images/Health-Record-Icons/Icon-Medical-Conditions.svg'),
  list_title: 'Medical Condition',
  icon: 'file-check',
  editor: 'ConditionEditor',
  message_translate: 'health-record.conditions.message',
  model_name: 'condition',
  resource: 'hr/condition/',
  plain_resource: 'condition',
  id: 'hr_id',
  headers: [
    {
      text: 'health-record.conditions.condition',
      value: 'record.condition',
    },
    {
      text: 'health-record.conditions.start-date',
      value: 'record.start_formatted',
    },
    {
      text: 'health-record.conditions.end-date',
      value: 'record.end_formatted',
    },
    {
      text: 'health-record.conditions.verification-status',
      value: 'record.verification_status.value',
    },
    {
      text: 'health-record.actions',
      value: 'actions',
      sortable: false,
      width: '100px',
    },
  ],
  sortables: {
    record: {
      start_formatted: 'start',
      end_formatted: 'end',
      condition: 'condition',
      verification_status: {
        value: 'verification_status',
      },
    },
  },
  show_menu: true,
  background: 'linear-gradient(122.25deg, #ad1457 3.07%, #d81b60 100%)',
  color: '#D81B60',
  opaque: '#F3CDDB',
}
